import { useCallback, useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'

import { AdvisorChatShell } from '@/modules/advisors/users/pages/chat/components/ChatShell/ChatShell'

import { useAdvisorsServiceAdvisorUsersControllerGetChatUsers } from '@/__generated__/queries'
import type { UserData } from '@/__generated__/requests'

export function Component() {
  const [searchedUser, setSearchedUser] = useState<string>('')
  const [selectedUser, setSelectedUser] = useState<UserData | undefined>(
    undefined,
  )
  const [isChatOpen, setIsChatOpen] = useState(false)

  const location = useLocation()
  const redirectedUserId = location.state?.userId

  const { data, isFetching, isLoading } =
    useAdvisorsServiceAdvisorUsersControllerGetChatUsers({
      query: searchedUser,
    })

  const users = useMemo<UserData[]>(() => data ?? [], [data])

  const findUser = useCallback(
    (id: number) => users.find(user => user.id === id),
    [users],
  )

  const handleChatOpen = () => {
    setIsChatOpen(true)
  }

  const handleChatClose = () => {
    setIsChatOpen(false)
  }

  const handleUserSelect = (id: number) => {
    setSelectedUser(findUser(id))
    handleChatOpen()
  }

  const handleUserSearch = (query: string) => {
    setSearchedUser(query)
  }

  useEffect(() => {
    if (!redirectedUserId || !users.length) return
    setSelectedUser(findUser(redirectedUserId))
    setIsChatOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return (
    <AdvisorChatShell
      isChatOpen={isChatOpen}
      isLoading={isLoading || isFetching}
      onChatClose={handleChatClose}
      onUserSearch={handleUserSearch}
      onUserSelect={handleUserSelect}
      searchedUser={searchedUser}
      selectedUser={selectedUser}
      users={users}
    />
  )
}

Component.displayName = 'AdvisorChat'
